import { useEffect, useState } from 'hooks';
import { SidebarStatus, StorageKey } from 'types/enums';
import { storage } from 'utils/util';

export const useSidebarStatus = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const setSidebarStatus = async () => {
      const sidebarStatus = await storage.get(StorageKey.SIDEBAR);
      setIsSidebarOpen(sidebarStatus === SidebarStatus.OPEN);
    };
    setSidebarStatus();
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      saveSidebarStatus();
    };

    const saveSidebarStatus = async () =>
      await storage.set(StorageKey.SIDEBAR, isSidebarOpen ? SidebarStatus.OPEN : SidebarStatus.CLOSE);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isSidebarOpen]);

  return { isSidebarOpen, toggleSidebar };
};
